/* eslint-disable react/no-unused-state */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Dropdown, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import CustomDropdownSettingsForm from './CustomDropdown.settingsForm';
import './customDropdown.scss';
import getLocalParams from '../localizationCustoms';

const CustomDropdown = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      options: [],
      data: props.data,
    };
    this.setValue = this.setValue.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
  }

  componentDidMount() {
    const {
      state: { value },
      props: { component: { data, dataSrc, valueProperty, template, useSessionStorage }, onChange },
    } = this;
    const { custom } = data || undefined;
    let optionsData = [];

    if (useSessionStorage) {
      const self = this;
      window.addEventListener('storage', (e) => {
        if (e.key === self.props.component.sessionStorageVariable) {
          const drivers = [{ name: 'Unoccupied' }];
          const policy = JSON.parse(window.sessionStorage.getItem('thePolicy'));
          if (policy?.drivers) {
            policy.drivers.forEach((element) => {
              element.id = (value?.value?.policySystemId === element.policySystemId) ? value.value.id : '';
              element.name = `${element.firstName} ${element.lastName}`;
              drivers.push(element);
            });
          }

          drivers.push({ name: 'Driver not listed' });

          const finalArray = drivers.map((driver) => (
            { value: driver, label: driver.name }
          ));

          const options = finalArray.map((obj) => ({
            value: obj.value,
            selectedLabel: obj.label,
            label: obj.label,
          }));

          self.setState({ value, options }, () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          });
        }
      });
    }

    if (
      data !== undefined
      && dataSrc !== undefined
      && dataSrc === 'values'
    ) {
      optionsData = data.values.map((dropdown) => ({
        selectedLabel: dropdown.label,
        label: dropdown.label,
        value: dropdown.value,
      }));

      this.setState({ value, options: optionsData }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else if (
      data !== undefined
      && dataSrc === 'custom'
      && custom !== undefined
      && valueProperty !== undefined
      && template !== undefined
    ) {
      try {
        // eslint-disable-next-line no-eval
        const extractedData = eval(custom);

        if (template !== '' && extractedData !== undefined && Array.isArray(extractedData) && extractedData.length > 0) {
          if (valueProperty === '') {
            const arrayTemplate = template.replace(/["]+/g, '').split(',');
            if (Array.isArray(arrayTemplate) && arrayTemplate.length > 0) {
              const labels = extractedData.map((v) => {
                const filteredLabel = arrayTemplate.reduce(
                  (result, key) => {
                    result[key] = v[key];
                    return result;
                  },
                  {},
                );
                return filteredLabel;
              });
              const joinedLabels = labels.map((label) => Object.values(label).join(' '));

              const finalArray = joinedLabels.map((label, index) => (
                { value: extractedData[index], label }
              ));

              optionsData = finalArray.map((obj) => ({
                value: obj.value,
                selectedLabel: obj.label,
                label: obj.label,
              }));

              this.setState({ value, options: optionsData }, () => {
                // eslint-disable-next-line react/destructuring-assignment
                onChange(this.state.value);
              });
            } else {
              this.setState({ value, options: [] }, () => {
                // eslint-disable-next-line react/destructuring-assignment
                onChange(this.state.value);
              });
            }
          } else {
            const arrayValueProperty = valueProperty.replace(/["]+/g, '').split(',');
            const arrayTemplate = template.replace(/["]+/g, '').split(',');
            if (Array.isArray(arrayValueProperty) && Array.isArray(arrayTemplate) && arrayValueProperty.length > 0 && arrayTemplate.length > 0) {
              const values = extractedData.map((v) => {
                const filteredValue = arrayValueProperty.reduce(
                  (result, key) => {
                    result[key] = v[key];
                    return result;
                  },
                  {},
                );
                return filteredValue;
              });

              const labels = extractedData.map((v) => {
                const filteredLabel = arrayTemplate.reduce(
                  (result, key) => {
                    result[key] = v[key];
                    return result;
                  },
                  {},
                );
                return filteredLabel;
              });

              const joinedValues = values.map((v) => Object.values(v).join(' '));
              const joinedLabels = labels.map((label) => Object.values(label).join(' '));

              const finalArray = joinedValues.map((v, index) => ({
                value: v,
                label: joinedLabels[index],
              }));

              optionsData = finalArray.map((obj) => ({ value: obj.value, selectedLabel: obj.label, label: obj.label }));

              this.setState({ value, options: optionsData }, () => {
                // eslint-disable-next-line react/destructuring-assignment
                onChange(this.state.value);
              });
            } else {
              this.setState({ value, options: [] }, () => {
                // eslint-disable-next-line react/destructuring-assignment
                onChange(this.state.value);
              });
            }
          }
        } else {
          this.setState({ value, options: [] }, () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          });
        }
      } catch (e) {
        if (e instanceof SyntaxError) {
          this.setState({ value, options: [] }, () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      data,
    } = this.props;
    if (prevProps.data !== data) {
      this.setState({
        data,
      });
    }
  }

  setValue = (v) => {
    const { state: { options }, props: { component: { useReviewLabel, label, reviewLabel, reviewObjValue }, onChange } } = this;
    const newLabel = useReviewLabel ? reviewLabel : label;
    const newObj = reviewObjValue
      ? { value: v, review: { label: newLabel, value: v[reviewObjValue] } }
      : { value: v, review: { label: newLabel, value: this.getTypelistValue(v) } };
    this.setState({ value: newObj, options }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  getTypelistValue = (v) => {
    const { options } = this.state;
    const option = options.find((o) => o.value === v);
    return option.label;
  };

  translateOptions = (options) => {
    const { intl } = this.props;
    return options.map((opt) => ({
      value: opt.value,
      selectedLabel: !opt.value.policySystemId ? intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }) : opt.label,
      label: !opt.value.policySystemId ? intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }) : opt.label,
    }));
  };

  render() {
    const {
      state: { value, options },
      props: { intl, component: { placeholder, defaultValue, id, hideCustomLabel, label, tooltip, data }, disabled },
    } = this;
    return (
      data !== undefined && (
        <>
          {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
                <Tooltip id="dropdown_tooltip" primary>
                  <FormattedMessage id={tooltip} defaultMessage={tooltip} />
                </Tooltip>
              )}
            </div>
          )}
          <Dropdown
            primary
            options={this.translateOptions(options)}
            placeholder={placeholder ? intl.formatMessage({ id: placeholder, defaultValue: placeholder }) : intl.formatMessage({ id: 'Select', defaultValue: 'Select' })}
            defaultValue={defaultValue}
            onChange={(v) => this.setValue(v)}
            value={value?.value ? value.value : null}
            disabled={disabled}
            id={`dropdown_${id}`}
          />
        </>
      )
    );
  }
};

const CustomDropdownWithIntl = injectIntl(CustomDropdown);

export default class DropdownComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Dropdown',
      icon: 'th-list',
      group: 'basic',
      weight: 80,
      documentation: '/userguide/#select',
      schema: DropdownComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customdropdown',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomDropdownSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomDropdownWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
